import React from "react";

const emptyExperience = {
  companyname: "",
  location: "",
  designation: "",
  joiningDate: "",
  relievingDate: "",
  experience: "",
};

// ✅ SAFE EXPERIENCE CALCULATION
const calculateExperience = (start, end) => {
  if (!start || !end) return "";

  const s = new Date(start);
  const e = new Date(end);

  if (e < s) return "Invalid";

  const diff = e - s;

  const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
  const months = Math.floor(
    (diff % (1000 * 60 * 60 * 24 * 365)) /
      (1000 * 60 * 60 * 24 * 30)
  );

  return `${years}y ${months}m`;
};

const EmpExperienceDetails = ({ data = [], setData }) => {

  // ✅ HANDLE CHANGE (IMMUTABLE)
  const handleChange = (index, e) => {
    const { name, value } = e.target;

    const updated = data.map((item, i) => {
      if (i !== index) return item;

      const newItem = {
        ...item,
        [name]: value,
      };

      if (name === "joiningDate" || name === "relievingDate") {
        newItem.experience = calculateExperience(
          newItem.joiningDate,
          newItem.relievingDate
        );
      }

      return newItem;
    });

    setData(updated);
  };

  // ✅ ADD EXPERIENCE
  const addExperience = () => {
    setData([...data, { ...emptyExperience }]);
  };

  // ✅ REMOVE EXPERIENCE
  const removeExperience = (index) => {
    const updated = data.filter((_, i) => i !== index);
    setData(updated.length ? updated : [{ ...emptyExperience }]);
  };

  return (
    <>
      {(data || []).filter(Boolean).map((exp, index) => (
        <div key={index} className="border rounded p-3 mb-4">
          <h6>Experience {index + 1}</h6>

          <div className="row g-3">

            <div className="col-lg-4">
              <label>Company Name</label>
              <input
                name="companyname"
                value={exp.companyname || ""}
                onChange={(e) => handleChange(index, e)}
                className="form-control"
              />
            </div>

            <div className="col-lg-4">
              <label>Location</label>
              <input
                name="location"
                value={exp.location || ""}
                onChange={(e) => handleChange(index, e)}
                className="form-control"
              />
            </div>

            <div className="col-lg-4">
              <label>Designation</label>
              <input
                name="designation"
                value={exp.designation || ""}
                onChange={(e) => handleChange(index, e)}
                className="form-control"
              />
            </div>

            <div className="col-lg-4">
              <label>Joining Date</label>
              <input
                type="date"
                name="joiningDate"
                value={exp.joiningDate || ""}
                onChange={(e) => handleChange(index, e)}
                className="form-control"
              />
            </div>

            <div className="col-lg-4">
              <label>Relieving Date</label>
              <input
                type="date"
                name="relievingDate"
                value={exp.relievingDate || ""}
                onChange={(e) => handleChange(index, e)}
                className="form-control"
              />
            </div>

            <div className="col-lg-4">
              <label>Experience</label>
              <input
                value={exp.experience || ""}
                readOnly
                className="form-control"
              />
            </div>

            <div className="col-12">
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => removeExperience(index)}
              >
                Remove
              </button>
            </div>

          </div>
        </div>
      ))}

      <button
        type="button"
        className="btn btn-outline-primary mt-2"
        onClick={addExperience}
      >
        Add Another Experience +
      </button>
    </>
  );
};

export default EmpExperienceDetails;